<template>
  <div class="container">
    <div class="block block-shadow block-custom rounded-10">
      <div class="table">
        <div class="table__head">
          <div class="table__header">
            <div class="table__header-item-col">
              <span class="table__header-item-meta">Invoice ID</span>
            </div>
            <div class="table__header-item-col">
              <span class="table__header-item-meta">Status</span>
            </div>
            <div class="table__header-item-col">
              <span class="table__header-item-meta"></span>
            </div>
          </div>
        </div>
        <div class="table__body">
          <slot />
          <div v-if="loading" class="table__loading position-absolute">
            <span>Loading...</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    total: {
      type: Number,
      default: 0
    },
    current: {
      type: Number,
      default: 0
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/bootstrap/mixins/_breakpoints.scss";

.block {
  width: 100%;
  &-custom {
    padding: 35px 20px;

    @include media-breakpoint-up(md) {
      padding: 50px;
    }
  }
}

.table {
  font-size: 15px;
  position: relative;

  &__shadow {
    background-image: linear-gradient(
      rgba(255, 255, 255, 0.5),
      rgb(255, 255, 255)
    );
    box-shadow: 0 -15px 45px 15px rgba(255, 255, 255, 0.5);
    content: "";
    height: 100px;
    pointer-events: none;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
  }

  &__loading {
    font-size: 20px;
    position: relative;
    z-index: 1;
    text-align: center;
    width: 100%;

    > svg {
      fill: #4c99d2;
    }
  }

  &__head {
    color: #232323;
    margin-bottom: 30px;
  }

  &__body {
    display: block;
    position: relative;
  }
}

.table__header {
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-flow: row wrap;
  padding: 35px 20px 0 20px;
  &-item {
    &-col {
      min-width: 200px;
      margin-bottom: 15px;
      margin-right: 30px;
      pointer-events: none;

      &:last-child {
        margin-right: 0;
      }
    }

    &-meta {
      font-weight: 500;
      display: inline-block;
    }
  }
  &:last-child {
    margin-bottom: 0;
  }
  @include media-breakpoint-up(md) {
    padding: 35px 30px 0 30px;
  }
}
</style>
